export default __webpack_public_path__ + "static/media/headP.c6b87e67.png";